export const NoteType = {
  AccessHolder: 1,
  GroupContract:2
};